import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { DashboardFeatureComponent } from './dashboard-feature/dashboard-feature.component';

export const DashboardRoute: Ng2StateDeclaration = {
    name: 'dashboard',
    url: '/dashboard',
    data: { requiresAuth: true },

    component: DashboardFeatureComponent
};
